import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from "../../../lib/components/ui/tabs";
import AdminLayout from "../layout";
import { MenuExtrasTab } from "./MenuExtrasTab";
import { MenuItemsTab } from "./MenuItemsTab";

export default function AdminMenu() {
	const { t } = useTranslation();
	return (
		<AdminLayout>
			<div className="space-y-6">
				<div className="flex flex-col gap-1 border-b border-border/40 pb-4">
					<motion.div
						initial={{ opacity: 0, x: -10 }}
						animate={{ opacity: 1, x: 0 }}
					>
						<h1 className="text-2xl font-bold tracking-tight text-foreground">
							{t("admin.menu.title")}
						</h1>
						<p className="text-sm text-muted-foreground">
							{t("admin.menu.subtitle")}
						</p>
					</motion.div>
				</div>

				<Tabs defaultValue="items" className="space-y-6">
					<TabsList className="bg-primary/10 p-1">
						<TabsTrigger value="items" className="px-6">
							{t("admin.menu.items_tab")}
						</TabsTrigger>
						<TabsTrigger value="extras" className="px-6">
							{t("admin.menu.extras_tab")}
						</TabsTrigger>
					</TabsList>

					<TabsContent
						value="items"
						className="space-y-6 outline-none animate-in fade-in-50 duration-300"
					>
						<MenuItemsTab />
					</TabsContent>

					<TabsContent
						value="extras"
						className="space-y-6 outline-none animate-in fade-in-50 duration-300"
					>
						<MenuExtrasTab />
					</TabsContent>
				</Tabs>
			</div>
		</AdminLayout>
	);
}
